import React from 'react';
import Hero from '../../components/pages/Solutions/Hero/Hero';
import OurExpertise from '../../components/pages/Solutions/OurExpertise/OurExpertise';
import TailoredStrategies from '../../components/pages/Solutions/TailoredStrategies/TailoredStrategies';
import OurApproach from '../../components/pages/Solutions/OurApproach/OurApproach';
import WhoWeWorkWith from '../../components/pages/Solutions/WhoWeWorkWith/WhoWeWorkWith';
import Advantage from '../../components/pages/Solutions/Advantage/Advantage';
import LetsBuild from '../../components/pages/Solutions/LetsBuild/LetsBuild';

const Solutions = () => {
  return (
    <div>
      <Hero />
      <OurExpertise />
      <TailoredStrategies />
      <OurApproach />
      <WhoWeWorkWith />
      <Advantage />
      <LetsBuild />
    </div>
  );
};

export default Solutions;
